import React from "react";

import {
  Button,
  Content,
  Grid,
  GridItem,
  Stack,
  StackItem,
  Flex,
  FlexItem
} from "@patternfly/react-core";

import { SectionPanel } from "shared/components/SectionPanel";
import { Carousel } from "shared/components/Carousel";
import VideoCard from "./VideoCard";
import { videos } from "../data/videos";

const VideosPanel = ({
  isCard = false,
  showHeader = true,
  showAction = true,
  isCarousel = false,
  title = "Nasze filmy",
  description = "Zobacz filmy prezentujące naszą szkołę.",
  actionLabel = "Zobacz więcej na YouTube",
  actionHref = null
}) => {
  const action =
    showAction && actionHref ? (
      <Button
        variant="primary"
        component="a"
        href={actionHref}
        target="_blank"
        rel="noopener noreferrer"
      >
        {actionLabel}
      </Button>
    ) : null;

  return (
    <SectionPanel
      isCard={isCard}
      variant="secondary"
      action={action}
    >
      <Stack hasGutter>
        {showHeader && (title || description) && (
          <StackItem>
            <Grid>
              <GridItem
                span={10}
                offset={1}
                lg={8}
                lgOffset={2}
              >
                <Stack hasGutter>
                  {title && (
                    <StackItem>
                      <Content
                        component="h1"
                        style={{ textAlign: "center" }}
                      >
                        {title}
                      </Content>
                    </StackItem>
                  )}

                  {description && (
                    <StackItem>
                      <Content
                        component="p"
                        style={{ textAlign: "center" }}
                      >
                        {description}
                      </Content>
                    </StackItem>
                  )}
                </Stack>
              </GridItem>
            </Grid>
          </StackItem>
        )}
        <StackItem>
          {isCarousel && videos.length > 4 ? (
            <Carousel
              items={videos}
              visibleItems={4}
              getKey={(video) => video.id}
              ariaLabel="Nasze filmy"
              showCounter
              controlsAlignment="center"
              renderItems={(items, controls) => (
                <Stack hasGutter>
                  <StackItem>
                      <Grid hasGutter>
                        {items.map((video) => (
                            <GridItem
                              key={video.id}
                              span={12}
                              md={6}
                              xl={3}
                            >
                              <VideoCard {...video} />
                            </GridItem>
                        ))}
                      </Grid>
                  </StackItem>

                  {/* <StackItem>
                      {controls}
                  </StackItem> */}
                  <StackItem>
                    <Flex justifyContent={{ default: "justifyContentCenter" }}>
                      <FlexItem style={{ width: "fit-content" }}>
                        {controls}
                      </FlexItem>
                    </Flex>
                  </StackItem>
                </Stack>
              )}
            />
          ) : (
              <Grid hasGutter>
                {videos.map((video) => (
                    <GridItem
                      key={video.id}
                      span={12}
                      md={6}
                      xl={3}
                    >
                      <VideoCard {...video} />
                    </GridItem>
                ))}
              </Grid>
          )}
        </StackItem>
      </Stack>
    </SectionPanel>
  );
};

export default VideosPanel;

